import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-initiation-type',
  templateUrl: './card-initiation-type.component.html',
  styleUrls: ['./card-initiation-type.component.scss']
})
export class CardInitiationTypeComponent implements OnInit {

  @Input() title!: string
  @Input() label: string
  @Input() loading: boolean = false

  constructor() { }

  ngOnInit(): void {
  }

}
